window.evtype = 'yc'
import('./index.js')
